import type { Category } from "~/models/Category"
import { useSearchStore } from "~/stores/searchStore"

export const useCategoriesStore = defineStore("categoriesStore", {
    state: (): {
        categories: Category[]
        loading: boolean
        currentCategorySelected: string | null
    } => ({
        categories: [],
        currentCategorySelected: null,
        loading: false,
    }),
    actions: {
        setCategories(categories: Category[]) {
            this.categories = categories
        },
        async fetchCategories() {
            const { get } = useOFetchCustom("departments")
            const { $bus } = useNuxtApp()
            this.loading = true
            await get(undefined, {
                onSuccess: ({ data }) => {
                    this.setCategories(data)
                    $bus.$emit("update:product-list", {
                        params: { category: this.currentCategorySelected },
                    })
                },
                onFinish: () => {
                    this.loading = false
                },
            })
        },
        getCategories() {
            if (this.categories.length === 0) {
                this.fetchCategories()
            }
        },
        setCurrentCategorySelected(category: string | null = null) {
            const searchStore = useSearchStore()
            searchStore.setCategory(category ?? undefined)
            this.currentCategorySelected = category
        },
        findCategoryByName(name: string) {
            const findInCategories = (
                categories: Category[]
            ): Category | null => {
                for (const category of categories) {
                    if (category.label === name) {
                        return category
                    }
                    if (category.children && category.children.length > 0) {
                        const found = findInCategories(category.children)
                        if (found) {
                            return found
                        }
                    }
                }
                return null
            }

            return findInCategories(this.categories) || null
        },
        checkIfCategoryExist(name: string) {
            return this.categories.some((category) => category.label === name)
        },
        findCategoryIdByName(name: string) {
            return this.findCategoryByName(name)?.id
        },
    },
})
